import React from 'react';
import Loadable from 'react-loading-overlay';

const OverlayLoader = (props)  => (
  <Loadable
    active={props.active}
    text={props.text}
    spinner
    background="rgba(255, 255, 255, 0.8)"
    color="rgb(108, 117, 125)"
  >
    {props.children}
  </Loadable>
);

export default OverlayLoader;



// WEBPACK FOOTER //
// ./src/components/overlayLoader.js